import './historias.css'
import resistanceReborn from '../../images/resistanceReborn.png';
import lordOscuro from '../../images/darth-vader-comic.jpg'
import riseEmpire from '../../images/riseEmpire.jpg';
import heirJedi from '../../images/heirJedi.jpg';
import masterApprentice from '../../images/master&apprentice.jpg';

import MenuSimple from "../ui/menuSimple";
import CardGrid from "../features/cardGrid";
import Footer from "../ui/footer";
const Historias = ()=>{

    const info = [
        {
            sectionName: 'historias',
            id: 0,
            image: resistanceReborn,
            text: "Una historia sobre la resistencia tras el ascenso de la Primera Orden",
            side: "light",
            title: "El renacer de la resistencia"
        },
        {
            sectionName: 'historias',
            id:1,
            image: lordOscuro,
            text: "La historia de Darth Vader y su ascenso en la orden Sith",
            side: "dark",
            title: "Darth Vader: Lord Oscuro"
        },
        {
            sectionName: 'historias',
            id:2,
            image: riseEmpire,
            text: "El surgimiento del Imperio tras la caída de la República",
            side: "dark",
            title: "El ascenso del Imperio"
        },
        {
            sectionName: 'historias',
            id:3,
            image: heirJedi,
            text: "El legado Jedi y el inicio de una nueva generación",
            side: "light",
            title: "El heredero del Jedi"
        },
        {   id:4,
            sectionName: 'historias',
            image: masterApprentice,
            text: "La relación entre maestro y aprendiz antes de la amenaza Sith",
            side: "light",
            title: "Maestro y aprendiz"
        }
    ];
    return(
        <>
            <MenuSimple />
            <CardGrid info={info}  />
            <Footer />
        </>
    )
}

export default Historias;